// --------------------------------------------------------------
// Created On: 2026-07-12
// Author: Dimitra Weinstein
//
// Last Modified: 2026-07-17
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React, { Fragment } from "react";

// Navigation buttons for the AI Agent Chat Window.
export default function AiAgentNavigationButtons(props: Props): Component {
  return (
    <Fragment>
      {/* AI Agent Window Navigation Buttons */}
      <div
        className="mb-4 mx-auto d-flex align-items-center justify-content-center"
        aria-label="Chat Bot Navigation Buttons"
      >
        {/* Hamburger menu button - Opens Navigation Drawer */}
        <button
          type="button"
          className="btn btn-sm btn-primary mx-auto w-25"
          onClick={() => props.onOpenNavigationDrawer()}
          data-test="hamburger-menu-button"
          title="Open Navigation Drawer"
        >
          <i className="fa fa-fw fa-bars" data-test="hamburger-menu-button-icon" />
        </button>
        {/* Clear chat history button (trash can icon) */}
        <button
          type="button"
          className="btn btn-sm btn-primary mx-auto w-25"
          onClick={() => props.onEndChatSession()}
          data-test="clear-chat-history-trash-can-button"
          title="Clear Chat History"
        >
          <i className="fa fa-trash" data-test="clear-chat-history-trash-can-button-icon" />
        </button>
        {/* Close agent window button */}
        <button
          type="button"
          className="btn btn-sm btn-primary mx-auto w-25"
          onClick={() => props.onCloseChatWindow()}
          data-test="close-chat-window-button"
          title="Close Chat Window"
        >
          <i className="fa fa-times" data-test="close-chat-window-button-icon"></i>
        </button>
      </div>
    </Fragment>
  );
}

interface Props {
  onOpenNavigationDrawer: () => void;
  onEndChatSession: () => void;
  onCloseChatWindow: () => void;
}
